import { useCallback, useContext } from 'react'
import { message, Modal } from 'antd'

import { useSelection } from '@shared/modules/next-table/hooks/use-selection'

import { ProductCategoriesService } from '../services/categories'
import { ProductCategoriesTableContext } from '../context'
import { useBackgroundNavigate } from '@shared/hooks'

export const useProductCategoriesTableActions = () => {
  const navigate = useBackgroundNavigate()

  const { state, handleFetch, handleReset, handleSelectAll, handleResetSelection } = useContext(ProductCategoriesTableContext)
  const selection = useSelection(state.selectedRowIds)

  const handleRemove = useCallback(() => {
    const action = async () => {
      const result = await ProductCategoriesService.actionByIds(selection, 'remove')

      if (result.status === 200) {
        message.success('Əməliyyat müvəffəqiyyətlə başa çatdı.')
        await handleFetch()
      } else {
        message.error(result.data)
      }
    }

    Modal.confirm({
      title: 'Silməyə əminsinizmi?',
      content: 'Silmə əməliyyatını təsdiqlədikdən sonra məlumatların geri qaytarılması mümkün olmayacaq.',
      onOk: action,
    })
  }, [handleFetch, selection])

  const goToCreate = useCallback(() => {
    navigate('/products/categories/create', { withBackground: true })
  }, [navigate])

  return { selection, handleFetch, handleResetSelection, handleSelectAll, handleReset, handleRemove, goToCreate }
}
